import React from 'react'
import { useForm } from 'react-hook-form'
import { Button, Base, Text, Header, Loader } from '@pet-notify/ui'

import { PlanInterval } from 'types/plan'
import style from './style.module.css'
import { ActivateInput } from 'services/orders'
import { usePlans } from 'hooks/plans'
import { formatMoney } from '@pet-notify/formatters'

type FormData = {
  planInterval: PlanInterval
}

type Props = {
  onSubmit: (data: FormData) => void
  state: Partial<ActivateInput>
}

function ChoosePlanForm({ state, ...props }: Props) {
  const { register, handleSubmit } = useForm<FormData>({
    defaultValues: {
      planInterval: state.planInterval || PlanInterval.Year,
    },
  })

  const plansQuery = usePlans()

  const onSubmit = handleSubmit(props.onSubmit)

  if (plansQuery.isLoading || !plansQuery.data) {
    return <Loader />
  }

  return (
    <>
      <Header as='h3' mb='4' size='xlarge'>
        Choose your plan
      </Header>

      <form onSubmit={onSubmit}>
        <Base mb='4'>
          {plansQuery.data.map(({ interval, amount }) => (
            <label key={interval} className={style.plan}>
              <input
                className={style.radio}
                type='radio'
                value={interval}
                {...register('planInterval')}
              />
              {interval === 'year' ? (
                <>
                  <div className={style.title}>
                    {formatMoney(Math.floor(amount / 12) / 100)} per month
                  </div>
                  <div className={style.subTitle}>Paid annually</div>
                  <div className={style.pill}>45% Savings</div>
                </>
              ) : (
                <>
                  <div className={style.title}>
                    {formatMoney(amount / 100)} per month
                  </div>
                  <div className={style.subTitle}>Paid monthly</div>
                </>
              )}
            </label>
          ))}
        </Base>

        <Button type='submit' mb='6'>
          Continue
        </Button>
      </form>

      <Text variant='note'>No commitments, cancel anytime.</Text>
    </>
  )
}

export default ChoosePlanForm
